import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=cf42a9ec&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf42a9ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf42a9ec')) {
      api.createRecord('cf42a9ec', component.options)
    } else {
      api.reload('cf42a9ec', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=cf42a9ec&scoped=true&", function () {
      api.rerender('cf42a9ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IBCuvEpl5HYn/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports